// frontend/src/components/Admin/TriAccessManager.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const TriAccessManager = ({ token, onVoltar }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [grantForm, setGrantForm] = useState({
    email: '',
    days: 30
  });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchUsersWithTriAccess();
  }, []);

  const fetchUsersWithTriAccess = async () => {
    try {
      setLoading(true);
      setError('');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      // Buscar usuários com acesso TRI
      const response = await api.get('/api/tri-access/all', config);
      setUsers(response.data.data || []);
    } catch (err) {
      console.error('Erro ao carregar usuários com acesso TRI:', err);
      setError('Erro ao carregar usuários com acesso TRI. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleGrantAccess = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.post('/api/tri-access/grant', grantForm, config);

      setMessage('Acesso TRI concedido com sucesso!');
      setGrantForm({
        email: '',
        days: 30
      });

      // Recarregar a lista de usuários
      fetchUsersWithTriAccess();

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error('Erro ao conceder acesso TRI:', err);
      setError(err.response?.data?.message || 'Erro ao conceder acesso TRI. Tente novamente.');
    }
  };

  const handleRemoveAccess = async (email) => {
    if (!window.confirm(`Tem certeza que deseja remover o acesso TRI do usuário com email ${email}?`)) {
      return;
    }

    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.delete(`/api/tri-access/remove/${email}`, config);

      setMessage('Acesso TRI removido com sucesso!');
      fetchUsersWithTriAccess();

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error('Erro ao remover acesso TRI:', err);
      setError(err.response?.data?.message || 'Erro ao remover acesso TRI. Tente novamente.');
    }
  };

  const filteredUsers = users.filter(user =>
    user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (user.createdBy && user.createdBy.nome.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={onVoltar}
              className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Voltar
            </button>
            <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Acesso TRI</h1>
          </div>

          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
            <p className="mt-4 text-gray-600">Carregando usuários...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={onVoltar}
            className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar
          </button>
          <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Acesso TRI</h1>
        </div>

        {message && (
          <div className="mb-6 p-4 rounded-lg bg-green-100 text-green-800">
            {message}
          </div>
        )}

        {error && (
          <div className="mb-6 p-4 rounded-lg bg-red-100 text-red-800">
            {error}
          </div>
        )}

        {/* Formulário para conceder acesso */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Conceder Acesso TRI</h2>

          <form onSubmit={handleGrantAccess}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email do Usuário *
                </label>
                <input
                  type="email"
                  name="email"
                  value={grantForm.email}
                  onChange={(e) => setGrantForm({...grantForm, email: e.target.value})}
                  placeholder="email@usuario.com"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Duração
                </label>
                <select
                  name="days"
                  value={grantForm.days}
                  onChange={(e) => setGrantForm({...grantForm, days: parseInt(e.target.value)})}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                >
                  <option value={30}>30 dias</option>
                  <option value={90}>90 dias</option>
                  <option value={180}>180 dias</option>
                </select>
              </div>
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                className="px-6 py-3 bg-violet-600 text-white font-semibold rounded-lg hover:bg-violet-700 transition-colors"
              >
                Conceder Acesso TRI
              </button>
            </div>
          </form>
        </div>

        {/* Barra de busca */}
        <div className="mb-6">
          <div className="relative">
            <input
              type="text"
              placeholder="Buscar usuários por email ou administrador criador..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
            />
            <svg className="w-5 h-5 text-gray-400 absolute left-3 top-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
        </div>

        {/* Lista de usuários com acesso TRI */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-800">Usuários com Acesso TRI</h3>
            <p className="text-sm text-gray-600 mt-1">{filteredUsers.length} usuário(s) encontrados</p>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Email
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Dias
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data de Início
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data de Expiração
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Criado por
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <tr key={user._id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">{user.email}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">{user.days} dias</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {new Date(user.startDate).toLocaleDateString('pt-BR')}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {new Date(user.expiryDate).toLocaleDateString('pt-BR')}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          user.isActive 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-red-100 text-red-800'
                        }`}>
                          {user.isActive ? 'Ativo' : 'Expirado'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {user.createdBy ? user.createdBy.nome : 'Desconhecido'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button
                          onClick={() => handleRemoveAccess(user.email)}
                          className="text-red-600 hover:text-red-900"
                          title="Remover acesso TRI"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="px-6 py-4 text-center text-sm text-gray-500">
                      Nenhum usuário com acesso TRI encontrado
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TriAccessManager;